import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Link,
} from '@mui/material';

const transmisionesMock = [
  {
    nombre: 'Futsal CAFS Nacional de Clubes C17 Club Aleman vs Villa hipodromo',
    fecha: '30 de Junio, 2025',
    url: 'https://www.youtube.com/watch?v=uzRwgGB8bqw&ab_channel=CAFSConfederacionArgentinaFutboldeSalon',
  },
  {
    nombre: 'Futsal CAFS Nacional de Clubes C17 Cementista (Mdz) vs CA Belgrano (Concepción) | ',
    fecha: '30 de Junio, 2025',
    url: 'https://www.youtube.com/watch?v=0npx-tWWLRA&ab_channel=CAFSConfederacionArgentinaFutboldeSalon',
  },
  {
    nombre: 'Futsal FIFUSA Intercontinental Cup Femenino',
    fecha: '5 de Agosto, 2025',
    url: 'https://www.youtube.com/@CAFSArgentinaFutsal',
  },
];

const Transmisiones = () => {
  const [transmisiones] = useState(transmisionesMock);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #031c32, #06437c)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 4,
        pb: 8,
      }}
    >
      <Typography
        variant="h5"
        sx={{ color: 'white', fontWeight: 'bold', mb: 3 }}
      >
        Transmisiones en Vivo
      </Typography>

      {transmisiones.map((transmision, index) => (
        <Card
          key={index}
          sx={{
            width: '90%',
            maxWidth: 400,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: 6,
            mb: 3,
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
              {transmision.nombre}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
              Fecha: {transmision.fecha}
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#06437c',
                '&:hover': { backgroundColor: '#022c43' },
                textTransform: 'none',
                borderRadius: 2,
                mb: 1,
              }}
              fullWidth
              href={transmision.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver Transmisión
            </Button>
            <Typography variant="body2">
              <Link
                href={transmision.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ wordBreak: 'break-all', color: '#06437c' }}
              >
                {transmision.url}
              </Link>
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default Transmisiones;
